<template>
  <div>
    <div class="search-registry-view margin-top-m margin-bottom-xs">
      <div class="grid-x">
        <RegistryUiSearchRegistryComponent />
        <RegistryUiBreadcrumbWrapper />
        <div v-if="searchRegistryErrorState" class="grid-x cell margin-bottom-xl">
          <AtomicUiNotification class="cell small-12 medium-6 small-margin-top-xxs medium-margin-top-s" severity="error" :closable="false">
            {{ errorMessages.searchRegistryError }} <br />
            <AtomicUiButton variant="link" class="link-body" @click="refreshSearchRegistry"> Refresh </AtomicUiButton>
          </AtomicUiNotification>
        </div>
        <template v-else>
          <RegistryUiRegistryResultsLoader v-if="registryResultsLoading" />
          <RegistryUiSearchRegistryResults />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { fireTag } from '@nuxt-common/util/app/utils/tagManager';
import { warn } from '@nuxt-common/util/app/utils/universalLogger';
import { useSearchRegistryStore } from '~/stores/searchRegistry';
import { useBaseStore } from '~/stores/base';
import { useEnvPropsStore } from '~/stores/envProps';
import { useAssociation } from '~/composables/useAssociation';
import { errorMessages } from 'config';

const { registryId } = useAssociation();
const searchRegistryStore = useSearchRegistryStore();
const baseStore = useBaseStore();
const envPropsStore = useEnvPropsStore();

const orgId = computed(() => (envPropsStore.envProps.entryPoint.toUpperCase() === 'MCOM' ? 12 : 13));
const registryResultsLoading = computed(() => searchRegistryStore.registryResultsLoading);
const redirectSearchTerm = computed(() => searchRegistryStore.redirectSearchTerm);
const giftGiverToSearchPage = computed(() => searchRegistryStore.giftGiverToSearchPage);
const searchRegistryErrorState = computed(() => searchRegistryStore.errorState);
const registrySearchTerm = computed(() => searchRegistryStore.registrySearchTerm);
const registrySearchOccasion = computed(() => searchRegistryStore.registrySearchOccasion);

const getKSValues = async () => {
  await baseStore.getKillSwitchConfig({
    orgId: orgId.value,
    regId: registryId.value,
  });
};

const refreshSearchRegistry = () => {
  searchRegistryStore.getSearchRegistryResults({
    orgId: orgId.value,
    registrySearch: registrySearchTerm.value,
    sortByOccasionType: registrySearchOccasion.value,
  });
};

onBeforeMount(async () => {
  await getKSValues();
});

onMounted(async () => {
  if (!giftGiverToSearchPage.value) {
    if (redirectSearchTerm.value || registrySearchTerm.value) {
      await searchRegistryStore.getSearchRegistryResults({
        orgId: orgId.value,
        registrySearch: redirectSearchTerm.value || registrySearchTerm.value,
        sortByOccasionType: registrySearchOccasion.value,
      });
      if (redirectSearchTerm.value) {
        searchRegistryStore.clearRedirectSearchTerm();
      }
    }
  }
  searchRegistryStore.setRegistryResultsTableVisibility(!!redirectSearchTerm.value || !!registrySearchTerm.value);
  if (!redirectSearchTerm.value) {
    fireTag('view', {
      page_name: 'find a registry',
      page_type: 'registry',
    });
  }
  try {
    const { ExperimentationTags } = await import('@nuxt-common/util/app/utils/experimentation');
    await ExperimentationTags.fireAdobeTags();
  } catch (e) {
    warn('Issue while loading ExperimentationTags -', e);
  }
});
</script>

<style lang="scss" scoped></style>
